import { ISmartProps } from './types';
import { StatefulTooltip as StatefullView } from './viewStateful';
import { StatefulPopover, StatefulPopoverProps, Popover, PopoverProps } from '../Popover';
import React from 'react';

export type TooltipProps = Omit<ISmartProps, 'css'>;

export const StatefulTooltip = StatefullView;

export const Tooltip = React.forwardRef(
	(
		{ triggerType = 'hover', ignoreBoundary = true, accessibilityType = 'tooltip', onMouseEnterDelay = 500, ...props }: StatefulPopoverProps,
		ref: any,
	) => {
		return <StatefulPopover
			ref={ref}
			triggerType={triggerType}
			accessibilityType={accessibilityType}
			ignoreBoundary={ignoreBoundary}
			onMouseEnterDelay={onMouseEnterDelay}
			dismissOnEsc={true}
			overrides={{
				Inner: {
					style: () => {
						return {
							width: 'unset',
						};
					},
				},
			}}
			{...props}
		/>
	},
);

export const StatelessTooltip = React.forwardRef(
	(
		{ triggerType = 'hover', ignoreBoundary = true, accessibilityType = 'tooltip', isOpen, onMouseEnterDelay = 500, ...props }: PopoverProps,
		ref: any,
	) => (
		<Popover
			isOpen={isOpen}
			ref={ref}
			triggerType={triggerType}
			accessibilityType={accessibilityType}
			ignoreBoundary={ignoreBoundary}
			onMouseEnterDelay={onMouseEnterDelay}
			{...props}
		/>
	),
);
